import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Main from "../Components/TimePageDashBoard/main";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";

function TimePage() {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 71).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    // sending page ids directly now.
    fetchShakespeareStatus(getCaseId(), 71, dispatch);
  }, [dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <div className="main-content p-t-130">
            <NavBar flaggedPageName="71" />
            <Main pageObj={pageObject} />
            <NotesSectionDashboard pageName={"Time Page"} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TimePage;
